<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__slaccountcash}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slaccountcash:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slaccountcash:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userId" label="用户ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" label="状态 0：申请提现 1：提现成功，2：提现失败" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bankNo" label="" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bank" label="所属银行" header-align="center" align="center"></el-table-column>
        <el-table-column prop="branch" label="支行" header-align="center" align="center"></el-table-column>
        <el-table-column prop="money" label="账户总额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="amount" label="到账金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="feeStatus" label="0处理中1成功2失败" header-align="center" align="center"></el-table-column>
        <el-table-column prop="feeBizFlow" label="手续费划拨编号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="fee" label="手续费" header-align="center" align="center"></el-table-column>
        <el-table-column prop="feeBear" label="手续费收取方式 1：平台垫付 2：个人承担" header-align="center" align="center"></el-table-column>
        <el-table-column prop="feeType" label="汇付手续费收取方式 1：内扣 2：外扣" header-align="center" align="center"></el-table-column>
        <el-table-column prop="type" label="提现方式：0--T+0，1---T+1  2---T+5" header-align="center" align="center"></el-table-column>
        <el-table-column prop="orderNo" label="取现订单号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="addTime" label="添加时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="addIp" label="添加IP" header-align="center" align="center"></el-table-column>
        <el-table-column prop="verifyTime" label="审核时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="verifyUserName" label="审核人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="verifyRemark" label="审核备注" header-align="center" align="center"></el-table-column>
        <el-table-column prop="feeRedenvelope" label="提现券ID，0：未使用提现券" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bizFlow" label="第三方流水号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="merchantFee" label="商户手续费" header-align="center" align="center"></el-table-column>
        <el-table-column prop="reconStatus" label="对账状态" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center"></el-table-column> -->
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:slaccountcash:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:slaccountcash:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './slaccountcash-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/slaccountcash/page',
        getDataListIsPage: true,
        exportURL: '/sys/slaccountcash/export',
        deleteURL: '/sys/slaccountcash',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
